import { render } from "./App.vue?vue&type=template&id=9f71b4cc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9f71b4cc&lang=css"
import "./App.vue?vue&type=style&index=1&id=9f71b4cc&lang=scss"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__